import React from 'react';
import {SoopAvatarCommon} from '@soop-ui/soop-ui';
import styles from './Streamer.module.scss';
import {useStationData} from '@/stores/channel/station';

const StreamerInfo = () => {
  const {station} = useStationData();
  const {userId: streamerId, nickname: streamerNickname} = station.detail || {};
  return (
    <>
      <div className={styles.streamer}>
        <SoopAvatarCommon
          className={styles.profile}
          mode='static'
          onClick={() => {}}
          size={52}
          userId={streamerId || ''}
          variant='default'
        />
        <div className={styles.info}>
          <p className={styles.nick}>{streamerNickname}</p>
          <span className={styles.id}>{streamerId}</span>
        </div>
      </div>
    </>
  );
};

export default StreamerInfo;
